import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, Modal, FormGroup, FormControlLabel, Stack } from '@mui/material';
import { isEqual, isEmpty } from 'lodash';

import SettingsIcon from '@mui/icons-material/Settings';

import AnnotationTemplateSettings from '../../components/AnnotationTemplateSettings';
import {
  renderCheckBox,
  renderIconButton,
  renderTextField
} from '../../components/MaterialMUIComponent';

const LIMIT_DATA_DEFAULT = '50';

const TemplateConfigLocationModal = props => {
  const { templateConfiguration, handleTemplateConfiguration, videoSelect } = props;
  const [openModal, setOpenModal] = React.useState(false);

  const body = (
    <Box
      style={{
        zIndex: 1800,
        position: 'absolute',
        backgroundColor: 'white',
        height: '90%',
        width: '90%',
        top: '5%',
        left: '5%',
        paddingTop: '1%',
        paddingRight: '1%',
        paddingLeft: '1%',
        paddingBottom: '1%'
      }}
    >
      <AnnotationTemplateSettings
        setClose={setOpenModal}
        videos={[videoSelect]}
        envSettings="LocationComponent"
      />
    </Box>
  );

  return (
    <>
      <Box display="row" justifyContent="space-between" fullwidth="true" mb={1}>
        <Checkbox
          size="small"
          checked={templateConfiguration.configuration}
          onChange={() =>
            handleTemplateConfiguration({
              ...templateConfiguration,
              configuration: !templateConfiguration.configuration
            })
          }
          sx={{
            color: '#2A3F90',
            '&.Mui-checked': {
              color: '#2A3F90'
            }
          }}
          value="variable"
        />
        Relacionar campos de las plantillas
        {renderIconButton({
          key: 'settingsTemplate',
          icon: <SettingsIcon />,
          onClick: () => setOpenModal(true),
          disabled: isEmpty(videoSelect)
        })}
      </Box>
      <Box marginLeft="2%">
        <FormGroup>
          <FormControlLabel
            key="view-datas-dataBase-option"
            control={renderCheckBox({
              key: 'checkbox-view-datas-db',
              onChange: () =>
                handleTemplateConfiguration({
                  ...templateConfiguration,
                  previewDataBase: !templateConfiguration.previewDataBase
                }),
              value: templateConfiguration.previewDataBase
            })}
            label="View data base"
          />
        </FormGroup>
      </Box>
      {templateConfiguration.previewDataBase && (
        <Stack direction="row" display="flex" justifyContent="flex-start" marginLeft="2%">
          {renderTextField({
            key: 'limit-searchig-data',
            label: 'Limit searching data',
            style: { width: '30%', marginRight: '2%' },
            moreProps: {
              value: isEmpty(templateConfiguration.limitDataConsulting)
                ? LIMIT_DATA_DEFAULT
                : templateConfiguration.limitDataConsulting,
              onChange: event =>
                handleTemplateConfiguration({
                  ...templateConfiguration,
                  limitDataConsulting: event.target.value.trim()
                })
            }
          })}
          <FormGroup>
            <FormControlLabel
              control={renderCheckBox({
                key: 'checkbox-view-allDatas-db',
                onChange: () =>
                  handleTemplateConfiguration({
                    ...templateConfiguration,
                    limitDataConsulting: isEqual(templateConfiguration.limitDataConsulting, 'All')
                      ? LIMIT_DATA_DEFAULT
                      : 'All'
                  }),
                value: isEqual(templateConfiguration.limitDataConsulting, 'All')
              })}
              label="All datas"
            />
          </FormGroup>
        </Stack>
      )}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        {body}
      </Modal>
    </>
  );
};

TemplateConfigLocationModal.defaultProps = {};
TemplateConfigLocationModal.propTypes = {
  templateConfiguration: PropTypes.object.isRequired,
  handleTemplateConfiguration: PropTypes.func.isRequired,
  videoSelect: PropTypes.object.isRequired
};

export default TemplateConfigLocationModal;
